export default __webpack_public_path__ + "static/media/error.2f05ff75.png";